<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1 class="start">Add new member</h1>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-text-field v-model="newMember.name" label="Name"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="2" lg="1">
        <v-text-field v-model="newMember.title" label="Title"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select
          v-model="newMember.type"
          :items="titles"
          item-text="name"
          item-value="id"
          label="Type"
        ></v-select>
      </v-col>
      <v-col cols="6" sm="6" md="2" lg="2">
        <v-switch v-model="newMember.active" :label="`Active`"></v-switch>
      </v-col>
      <v-col cols="6" sm="12" md="12" lg="3">
        <v-file-input filled prepend-icon="mdi-camera" v-model="newMember.photoUrl" label="Photo"></v-file-input>
      </v-col>
      <v-col cols="12">
        <v-textarea v-model="newMember.description" auto-grow rows="1" label="Description"></v-textarea>
      </v-col>

      <v-col cols="12">
        <v-btn :loading="loading" color="white" elevation="1" @click="create">Add</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex" cols="12" sm="12" md="12">
        <v-select
          v-model="id"
          :items="members"
          item-text="name"
          item-value="id"
          dense
          label="Member to edit"
          filled
          v-on:change="updateItem"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="id">
      <v-col cols="9" sm="6" md="4" lg="3">
        <v-text-field v-model="member.name" label="Name"></v-text-field>
      </v-col>
      <v-col cols="3" sm="2" md="1">
        <v-text-field v-model="member.title" label="Title"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-select
          v-model="member.type"
          :items="titles"
          item-text="name"
          item-value="id"
          label="Type"
        ></v-select>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch @change="savePrev" :click="savePrev" v-model="member.active" :label="`Active`"></v-switch>
      </v-col>

      <v-col v-if="member.positions" cols="12">
        <v-textarea v-model="member.positions" auto-grow rows="1" label="Positions (html)"></v-textarea>
      </v-col>

      <v-col cols="12">
        <v-textarea v-model="member.description" auto-grow rows="1" label="Description"></v-textarea>
      </v-col>
      <v-col cols="12" v-if="member.awards">
        <v-textarea v-model="member.awards" auto-grow rows="1" label="Awards"></v-textarea>
      </v-col>
      <v-col cols="12" md="6">
        <v-img class="image" contain :src="member.photoUrl"></v-img>
      </v-col>
      <v-col cols="12" md="3">
        <v-file-input v-model="newFile" label="New photo" ></v-file-input>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn :loading="loading" color="white" elevation="1" @click="update">Update</v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn :loading="loading" color="red" elevation="1" @click="delet">Delete</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { uploadPhoto } from "@/helpers/storage.js";

export default {
  name: "MembersEdit",
  data() {
    return {
      id: null,
      prevStatus:null,
      newFile: null,
      member: { active: false },
      loading: false,
      titles: [
        { id: 0, name: "Visiting Scholars" },
        { id: 1, name: "Instructors" },
        { id: 2, name: "Lab Managers" },
        { id: 3, name: "Postdoctoral Research Fellows" },
        { id: 4, name: "PhD Students" },
        { id: 5, name: "Master Students" },
        { id: 6, name: "Undergraduate Students" },
        { id: 7, name: "High School Students" },
        { id: 10, name: "Director/PI" }
      ],
      newMember: {
        name: null,
        type: null,
        title: null,
        active: false,
        description: null,
        photoUrl: null
      }
    };
  },
  computed: {
    ...mapState(["loadingMembers", "members"]),
    ...mapGetters(["getMember"])
  },
  mounted() {
    if (!this.members.length) this.$store.dispatch("cargarMembers");
  },

  methods: {
    savePrev(){
      if(this.prevStatus==null){
        this.prevStatus=!this.member.active
        
        //console.log(this.member.active,this.prevStatus, x.getTime())
      }
      
    },
    updateItem() {
      this.member = this.getMember(this.id);
      this.prevStatus=null
    },
    update() {
      if(!this.member.active && this.prevStatus){
        let x = new Date()
        this.member.endperiod = x.getTime()
      }
      this.loading = true;
      if(this.newFile!=null){
        this.newFileMet();
      }
        if (this.id)
          this.$store
            .dispatch("updateMember", this.member)
            .then(() => ((this.loading = false), alert("Updated!")));
    },
    create() {
      this.loading = true;
      if (this.newMember.photoUrl != null) {
        let updatedItem = {};
        Object.assign(updatedItem, this.newMember);
        let x = new Date()
        updatedItem.startperiod = x.getTime()
        delete updatedItem.photoUrl;
        this.$store.dispatch("addMember", updatedItem).then(id => {
          if(this.newMember.photoUrl!=null){
            uploadPhoto("members", id, this.newMember.photoUrl).then(link => {
              updatedItem.photoUrl = link;
              updatedItem.id = id;
              this.$store.dispatch("updateMember", updatedItem).then(() => {
                this.loading = false;
                alert("Content created!");
              });
            });
          }
        });
      } else {
        this.loading = false;
        alert("You need to upload a picture!");
      }
    },
    delet() {
      this.loading = true;
      if (this.id)
        this.$store
          .dispatch("deleteMember", this.member)
          .then(() => (this.loading = false));
      this.member = {};
    },
    newFileMet() {
      uploadPhoto("members", this.member.id, this.newFile).then(link => {
        this.member.photoUrl = link;
        this.$store
          .dispatch("updateMember", this.member)
          .then(() => alert("Photo updated!"));
      });
    }
  }
};
</script>

<style scoped>
.start {
  text-align: start;
}
</style>